import { Component, OnInit } from '@angular/core';
import { Forgotpassword } from './forgotpassword';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { environment } from "src/environments/environment";

declare const $;
declare var gtag;
declare var fbq;

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit {

  constructor(private service:AppService,private router:Router) { }

  forgot=new Forgotpassword();
  loader:boolean=false;
  successMsg:string;
  errorMsg:string;
  forgotForm:boolean=true;
  verifyForm:boolean=false;
  passwordForm:boolean=false;

  ngOnInit() {
    if(environment.production){
    this.service.sendEvents("Completeforgotpassword", "forgotpassword", "ForgotPassword");

    fbq('track', "CompleteForgotPassword" , {
      content_type: "forgotpassword",
      content_title: this.router.url,
    });
  }

    if(this.service.isLoggedIn()){
      this.router.navigateByUrl("");
    }
  }

  showmobile:string;
  auth_token:string;
 

  sendOtp(){

    this.errorMsg="";
    this.successMsg="";
    this.loader=true;
    this.service.loaderStatus=true;

    this.service.post('/sendOtpByMobile',{type:"Web",mobile:this.forgot.mobile}).subscribe(
      data=>{
        if(data[0].error=='0'){
          this.successMsg=data[0].msg;
          this.auth_token=data[0].auth_token;
          var mobile=this.forgot.mobile;
          this.showmobile=mobile.substring(6,10);

          this.forgotForm=false;
          this.verifyForm=true;

          setTimeout(function(){ $('#pass1').focus(); },100);
           

        }else{
          this.errorMsg=data[0].msg;
        }

        this.loader=false;
        this.service.loaderStatus=false;
      },
      error=>{
        this.errorMsg=error.errorDesc;
        
        this.loader=false;
        this.service.loaderStatus=false;
      }
    );
  }

  resendOtp(){

    this.errorMsg="";
    this.successMsg="";
    this.loader=true;

    this.service.post('/resendOtp',{type:"Web",auth_token:this.auth_token}) 
    .subscribe(data => {
      if (data[0].error == '1') { 
        this.errorMsg=data[0].msg;
      }else{
        this.successMsg=data[0].msg;
      } 
      this.loader=false;
    },
    error=>{
      this.errorMsg=error.errorDesc;
      this.loader=false;
    } );
  }

  verfiyOtp(){

    this.errorMsg="";
    this.successMsg="";
    this.loader=true;

    var otp=(this.forgot.pass1)+(this.forgot.pass2)+(this.forgot.pass3)
    this.service.post('/verifyOtp',{type:"Web",otp:otp,auth_token:this.auth_token})
      .subscribe(
        data=>{
            if(data[0].error=='0'){
              this.successMsg=data[0].msg; 
              this.passwordForm=true;
              this.verifyForm=false;
            }else{
              this.errorMsg=data[0].msg;
            } 
            this.loader=false;
        },
        error=>{
          this.errorMsg=error.errorDesc; 
          this.loader=false;
        }
      );
  }

  updatePassword(){

    this.errorMsg="";
    this.successMsg="";
    this.loader=true;

    if(this.forgot.password==this.forgot.confirm_password){

        this.service.post('/updatePasswordByToken',{type:"Web",password:this.forgot.password,confirm_password:this.forgot.confirm_password,auth_token:this.auth_token})
          .subscribe(
            data=>{
                if(data[0].error=='0'){
                  this.successMsg=data[0].msg;
                  this.passwordForm=false;
                  this.forgotForm=true;
                  this.forgot=new Forgotpassword();

                  localStorage.setItem('currentUser',JSON.stringify(data[0]));
                  this.router.navigateByUrl('/');
                }else{
                  this.errorMsg=data[0].msg;
                }

                this.loader=false;
            },
            error=>{
              this.errorMsg=error.errorDesc; 
              this.loader=false;
            }
          )
    }else{
      this.errorMsg="Password and confirm password must be same";
      this.loader=false;
    }

  }

  numberOnly(event): boolean { 
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}
